import { render, staticRenderFns } from "./leadCenter.vue?vue&type=template&id=0472efea&scoped=true"
import script from "./leadCenter.vue?vue&type=script&lang=js"
export * from "./leadCenter.vue?vue&type=script&lang=js"
import style0 from "./leadCenter.vue?vue&type=style&index=0&id=0472efea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472efea",
  null
  
)

export default component.exports